// IMPORTANT: Initialize Sentry before any other imports
import './sentry';

import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { applyDkNativeEmbedClass, applyEmbedBottomChromeOverride } from './utils/embedChrome';
import { reportEmbedBottomChrome } from './utils/adReporting';
import { isGamMockEnabled, installGamMock } from './dev/gamMock';

// First, because it decides which stylesheet value the chrome resolves to: the DK app
// reserves for its tab bar, a bare web iframe reserves nothing. Width cannot tell them
// apart — see isDkNativeEmbed.
applyDkNativeEmbedClass();

// Then, before first paint: if the embedder told us how far its chrome overlaps the
// iframe (`?bottomInset=NN`), pinned elements should position against that from the
// outset rather than against the default and then jump. Set inline, so it outranks
// whichever stylesheet value the class above selected.
applyEmbedBottomChromeOverride();

// Immediately after, so Sentry records whether DK sent an inset at all — the contract
// has been live since v1.5.168 with no confirmation it was ever implemented, and an
// unsent inset and a rejected one are indistinguishable from the rendered result.
reportEmbedBottomChrome();

// `?gamMock=1`: stand in for Google's ad server, which never fills on localhost.
// Must install before anything queues GPT work; index.html skips the real gpt.js
// under the same flag so the two never fight over window.googletag.
if (isGamMockEnabled()) {
  installGamMock();
}

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

if (import.meta.env.DEV) {
  console.log(`[Squares] ${import.meta.env.MODE} mode | API: ${API_URL}`);
}

createRoot(document.getElementById('root')!).render(<App />);
